// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","inner":"header_inner__WfBSd","logo":"header_logo__UESgy"};